import React from "react";

export const ErrorMarkIconComponent = () => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.40214 18.5208L11.4746 6.27063C12.5975 4.32675 15.4032 4.32675 16.5262 6.27081L23.5984 18.5206C24.7215 20.4649 23.3183 22.8958 21.0727 22.8958H6.92801C4.68241 22.8958 3.27917 20.4649 4.40214 18.5208ZM22.0828 19.3958L15.0105 7.14598C14.5613 6.36832 13.4389 6.36832 12.9898 7.1458L5.91738 19.396C5.46824 20.1735 6.02949 21.1458 6.92779 21.1458H21.0725C21.9708 21.1458 22.532 20.1735 22.0828 19.3958ZM14 10.9375C14.4487 10.9375 14.8186 11.2246 14.8691 11.5945L14.875 11.6813V15.1521C14.875 15.5628 14.4832 15.8958 14 15.8958C13.5513 15.8958 13.1814 15.6087 13.1309 15.2388L13.125 15.1521V11.6813C13.125 11.2705 13.5168 10.9375 14 10.9375ZM15.0864 18.0233C15.0232 17.4825 14.5609 17.0627 14 17.0627C13.3959 17.0627 12.9062 17.5496 12.9062 18.1501L12.9136 18.2896C12.9768 18.8304 13.4391 19.2502 14 19.2502C14.6041 19.2502 15.0938 18.7634 15.0938 18.1628L15.0864 18.0233Z"
            fill="#EB5934"
        />
    </svg>
);
